import React from 'react';
import PropTypes from 'prop-types';
import styles from '../CustomInput/CustomInput.module.css'; // Reuse the same styles

const CustomPinInput = ({
  label,
  value,
  onEditClick,
  disabled = true,
  style,
  labelColor = '#000',
  labelFontWeight = 500,
}) => {
  const labelPropsStyle = {
    color: labelColor,
    fontWeight: labelFontWeight,
  };

  return (
    <div className={styles.lInputWrapper} style={style}>
      <label style={labelPropsStyle}>{label}</label>
      <div className={styles.inputWrapper}>
        <input
          type="text"
          value="••••" // Always show dots
          disabled={disabled}
          readOnly
        />
        <div
          onClick={onEditClick}
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '20px',
            height: '20px',
          }}
        >
          {/* You can import and use EditIcon here */}
          <span style={{ color: '#dc2626', fontSize: '16px' }}>✏️</span>
        </div>
      </div>
    </div>
  );
};

CustomPinInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onEditClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  labelColor: PropTypes.string,
  labelFontWeight: PropTypes.number,
};

export default CustomPinInput;
